import {
  creditFeaturesResponseSchema,
  creditTiersSEResponseSchema,
  initiateTierMigrationResponseSchema,
} from '@/api/credit/schemas';
import { creditTierMigrationInfoResponseSchema } from '@/api/credit/tierMigrationSchemas';
import type { CreditActionsResponse } from '@/api/credit/types';
import { endpoints } from '@/api/endpoints';
import { apiRequest, apiRequestWithoutSuffix } from '@/api/utils/api';
import type { OverdueInfoResponse } from '@/types/credit';

export const getCreditActions = () =>
  apiRequest<CreditActionsResponse>({ url: endpoints.credit.actions, method: 'GET' });

export const getOverdueInfo = () =>
  apiRequest<OverdueInfoResponse>({ url: endpoints.credit.overdue, method: 'GET' });

export const getFeatures = () =>
  apiRequest({ url: endpoints.credit.featuresSteps, method: 'GET', schema: creditFeaturesResponseSchema });

export const getCreditTiers = async () => {
  const result = await apiRequestWithoutSuffix({
    url: endpoints.credit.amount,
    method: 'GET',
    schema: creditTiersSEResponseSchema,
  });
  return result.data;
};

export const getCreditTierMigrationInfo = () =>
  apiRequest({
    url: endpoints.credit.tierMigration.root,
    method: 'GET',
    schema: creditTierMigrationInfoResponseSchema,
  });

export const initiateTierMigration = () =>
  apiRequest({
    url: endpoints.credit.tierMigration.root,
    method: 'POST',
    schema: initiateTierMigrationResponseSchema,
  });

export const migrateTier = (tierMigrationId: string) =>
  apiRequest<void>({ url: endpoints.credit.tierMigration.tierMigrationId(tierMigrationId), method: 'POST' });
